/**
 * 日期工具函数
 */

/**
 * 格式化日期为字符串
 * @param date 日期对象或时间戳
 * @param format 格式化模板，默认为 'YYYY-MM-DD HH:mm:ss'
 */
export function formatDate(date: Date | number | string, format: string = 'YYYY-MM-DD HH:mm:ss'): string {
  const d = new Date(date);
  
  const year = d.getFullYear();
  const month = d.getMonth() + 1;
  const day = d.getDate();
  const hours = d.getHours();
  const minutes = d.getMinutes();
  const seconds = d.getSeconds();

  const formatMap: { [key: string]: number } = {
    'YYYY': year,
    'MM': month,
    'DD': day,
    'HH': hours,
    'mm': minutes,
    'ss': seconds
  };

  let result = format;
  Object.entries(formatMap).forEach(([key, value]) => {
    result = result.replace(key, value.toString().padStart(2, '0'));
  });

  return result;
}

/**
 * 将字符串转换为日期对象
 * @param dateStr 日期字符串
 */
export function parseDate(dateStr: string): Date {
  return new Date(dateStr);
}

/**
 * 获取相对时间描述
 * @param date 要比较的日期
 * @param baseDate 基准日期，默认为当前时间
 */
export function getRelativeTime(date: Date | number | string, baseDate: Date | number | string = new Date()): string {
  const d1 = new Date(date);
  const d2 = new Date(baseDate);
  
  const diff = d2.getTime() - d1.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 365) {
    return `${Math.floor(days / 365)}年前`;
  }
  if (days > 30) {
    return `${Math.floor(days / 30)}个月前`;
  }
  if (days > 0) {
    return `${days}天前`;
  }
  if (hours > 0) {
    return `${hours}小时前`;
  }
  if (minutes > 0) {
    return `${minutes}分钟前`;
  }
  return '刚刚';
}
